import { createAction, props } from "@ngrx/store";
import { Alarms } from "src/types/alerts.types";


export const alarms = createAction(
    '[ADD] alarmsData',
    props<{ alarmsData: Alarms }>()
  );